import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'

function RegisteredPlayersRoundFirebase({id, roundId, players, setPlayers, requestCount, setRequestCount}) {


    const [show, setShow] = useState(false);

    useEffect(() => {

        try {
            const playersRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("players");
            playersRef.onSnapshot(({docs}) => {
                const players = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setPlayers(players);
            })
        } catch (error) {
            console.log("error", error)
        }

    }, [id, roundId, requestCount])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    async function removeHandler(e, playerId) {
        e.preventDefault();
        try {
            const playerRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId).collection("players").doc(playerId);
            playerRef.delete();
            setRequestCount(requestCount+1)
        } catch (error) {
            
        }
    }

    return (
        <React.Fragment>
            <div className="card card-header">
                <div onClick={toggle}>
                    Registrerte spillere <span className="float-right"><i className={show ? "fas fa-chevron-down" : "fas fa-chevron-up"}></i></span>
                </div>
            </div>
            {show && (
                <ul className="list-group mb-4">
                    {players?.map((player, index) => {
                        return (
                        <li key={index} className="list-group-item">{player.player_name} 
                            <span className="float-right">
                                <i onClick={(e) => removeHandler(e, player.id)} className="fas fa-trash text-danger"></i>
                            </span>
                        </li>
                        )
                    })}
                    
                </ul>
            )}
            <hr />
        </React.Fragment>

    )

}
export default RegisteredPlayersRoundFirebase